<template>
  <div id="settings">
    <AccountSettings />
  </div>
</template>

<script>
import AccountSettings from './components/AccountSettings.vue';

export default {
  components: {
    AccountSettings,
  },

  data: () => ({}),
};
</script>

<style lang="scss">
  #settings {
    .el-card {
      margin-bottom: 20px;

      .el-form-item__content {
        font-size: 16px;
      }

      .el-form-item {
        .el-form-item__label {
          font-size: 14px;
          margin-bottom: 10px;
        }

        .el-form-item__content {
          font-size: 16px;
        }
      }

      .el-input {
        &.is-disabled input {
          border-bottom-width: 0;
          cursor: initial;
          padding-left: 0;
        }

        &.emailInput {
          input {
            text-overflow: ellipsis;
          }
        }
      }

      .el-select {
        width: 100%;

        .el-input__inner {
          border-radius: 20px;
          background-color: white;
          color: black;
        }
      }

      .APReminderSelect {
        .el-row {
          min-width: 100%;
        }

        .el-form-item {
          margin-bottom: 5px;
        }

        .el-checkbox-button,
        .el-radio-button {
          .el-radio-button__inner,
          .el-checkbox-button__inner {
            padding: 8px;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            margin-right: 5px;
            border-left: unset;
            border: 1px solid white;
            color: white;
            border-color: white;
            background-color: transparent;
          }

          &.is-checked,
          &.is-active {
            .el-radio-button__inner,
            .el-checkbox-button__inner {
              border-width: 0;
              border-left: unset;
              border: 1px solid #00ace2;
              background-color: #00ace2;
              box-shadow: none;
            }
          }
        }
      }
    }
  }
</style>
